var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"direct-invite"},[_c('p',{staticClass:"direct-invite__note"},[_c('strong',{staticClass:"direct-invite__important"},[_vm._v(_vm._s(_vm.warningNoticeText))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.noteText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }